let inject = ['$scope', '$uibModalInstance','modalOptions', '$timeout'];

class ModalMapController {
  constructor ($scope,$uibModalInstance,modalOptions, $timeout) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.activateMap = false;
    this.$uibModalInstance = $uibModalInstance;
    this.map = Object.assign({}, modalOptions);
    this.$timeout(() => {
      this.activate();
    }, 1000);
  }

  activate(){
    this.activateMap = true;
    this.$timeout(() => {
      this.activateMap = false;
    }, 1000);
  }

  refresh(){
    this.activateMap = true;
    this.$timeout(() => {
      this.activateMap = false;
    }, 1000);
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

ModalMapController.$inject = inject;

export default ModalMapController;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/modal-map/modal-map.controller.js
 **/